import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "calendar-page" }
const _hoisted_2 = { class: "calendar-header" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "page-title" }
const _hoisted_5 = { class: "page-subtitle" }
const _hoisted_6 = { class: "calendar-content" }
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "calendar-controls" }
const _hoisted_9 = { class: "view-toggle" }
const _hoisted_10 = { class: "tags-container" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  key: 0,
  class: "month-view"
}
const _hoisted_13 = { class: "calendar-nav" }
const _hoisted_14 = { class: "current-month" }
const _hoisted_15 = { class: "calendar-grid" }
const _hoisted_16 = { class: "weekdays" }
const _hoisted_17 = { class: "days-grid" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "day-number" }
const _hoisted_20 = { class: "day-events" }
const _hoisted_21 = {
  key: 0,
  class: "more-events"
}
const _hoisted_22 = {
  key: 1,
  class: "list-view"
}
const _hoisted_23 = {
  key: 0,
  class: "events-list"
}
const _hoisted_24 = { class: "event-date" }
const _hoisted_25 = { class: "event-day" }
const _hoisted_26 = { class: "event-month" }
const _hoisted_27 = { class: "event-content" }
const _hoisted_28 = { class: "event-header" }
const _hoisted_29 = { class: "event-time" }
const _hoisted_30 = { class: "event-title" }
const _hoisted_31 = { class: "event-description" }
const _hoisted_32 = { class: "event-footer" }
const _hoisted_33 = { class: "event-tags" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "no-events" }
const _hoisted_36 = { class: "event-detail" }
const _hoisted_37 = { class: "detail-header" }
const _hoisted_38 = { class: "detail-content" }
const _hoisted_39 = { class: "detail-meta" }
const _hoisted_40 = { class: "meta-item" }
const _hoisted_41 = { class: "meta-item" }
const _hoisted_42 = {
  key: 0,
  class: "meta-item"
}
const _hoisted_43 = { class: "detail-description" }
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = {
  key: 0,
  class: "detail-actions"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_tag = _resolveComponent("van-tag")!
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavBar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('calendar.title')), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('calendar.subtitle')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_van_button, {
              type: $setup.viewMode === 'list' ? 'primary' : 'default',
              size: "small",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.viewMode = 'list'))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('calendar.listView')), 1)
              ]),
              _: 1
            }, 8, ["type"]),
            _createVNode(_component_van_button, {
              type: $setup.viewMode === 'month' ? 'primary' : 'default',
              size: "small",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.viewMode = 'month'))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('calendar.monthView')), 1)
              ]),
              _: 1
            }, 8, ["type"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.tagList, (tag) => {
            return (_openBlock(), _createElementBlock("div", {
              key: tag.id,
              class: _normalizeClass(["tag", { 'active': $setup.selectedTags.indexOf(tag.name) !== -1 }]),
              type: "primary",
              size: "medium",
              onClick: ($event: any) => ($setup.handleSelectedTag(tag))
            }, _toDisplayString(tag.name), 11, _hoisted_11))
          }), 128))
        ]),
        ($setup.viewMode === 'month')
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createVNode(_component_van_button, {
                  icon: "arrow-left",
                  size: "small",
                  onClick: $setup.prevMonth
                }, null, 8, ["onClick"]),
                _createElementVNode("h2", _hoisted_14, _toDisplayString($setup.currentMonthText), 1),
                _createVNode(_component_van_button, {
                  icon: "arrow",
                  size: "small",
                  onClick: $setup.nextMonth
                }, null, 8, ["onClick"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.weekdays, (day) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: day,
                      class: "weekday"
                    }, _toDisplayString(day), 1))
                  }), 128))
                ]),
                _createElementVNode("div", _hoisted_17, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.calendarDays, (day) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: day.id,
                      class: _normalizeClass(["calendar-day", {
                  'current-month': day.isCurrentMonth,
                  'today': day.isToday,
                  'has-events': day.events.length > 0,
                  'selected': $setup.selectedDate === day.date
                }]),
                      onClick: ($event: any) => ($setup.selectDate(day))
                    }, [
                      _createElementVNode("div", _hoisted_19, _toDisplayString(day.day), 1),
                      _createElementVNode("div", _hoisted_20, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(day.events.slice(0, 2), (event) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: event.id,
                            class: "event-dot",
                            style: _normalizeStyle({ backgroundColor: $setup.getEventColor(event.activityType) })
                          }, null, 4))
                        }), 128)),
                        (day.events.length > 2)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, " +" + _toDisplayString(day.events.length - 2), 1))
                          : _createCommentVNode("", true)
                      ])
                    ], 10, _hoisted_18))
                  }), 128))
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        ($setup.viewMode === 'list')
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
              ($setup.events && $setup.events.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.events, (event) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: event.id,
                        class: _normalizeClass(["event-item", `event-type-${event.type}`])
                      }, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, _toDisplayString($setup.formatEventDay(event.startTime)), 1),
                          _createElementVNode("div", _hoisted_26, _toDisplayString($setup.formatEventMonth(event.startTime)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("span", {
                              class: "event-type",
                              style: _normalizeStyle({ color: $setup.getEventColor(event.activityType) })
                            }, _toDisplayString($setup.getEventTypeText(event.activityType)), 5),
                            _createElementVNode("span", _hoisted_29, _toDisplayString($setup.getEventDateText(event)), 1)
                          ]),
                          _createElementVNode("h3", _hoisted_30, _toDisplayString(event.title), 1),
                          _createElementVNode("p", _hoisted_31, _toDisplayString(event.description), 1),
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("div", _hoisted_33, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(event.tags, (tag) => {
                                return (_openBlock(), _createBlock(_component_van_tag, {
                                  key: tag,
                                  class: "tag",
                                  type: "primary"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(tag), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _createVNode(_component_van_button, {
                              size: "mini",
                              plain: "",
                              onClick: ($event: any) => ($setup.handleEventClick(event))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('calendar.viewDetails')), 1)
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ])
                        ])
                      ], 2))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _createVNode(_component_van_empty, {
                        description: _ctx.$t('calendar.noEvents')
                      }, null, 8, ["description"])
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_van_popup, {
          show: $setup.showEventDetail,
          "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (($setup.showEventDetail) = $event)),
          position: "bottom",
          round: "",
          style: { height: '60%' }
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("h3", null, _toDisplayString($setup.selectedEvent?.title), 1),
                _createVNode(_component_van_icon, {
                  name: "cross",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showEventDetail = false))
                })
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, [
                    _createVNode(_component_van_icon, { name: "clock" }),
                    _createElementVNode("span", null, _toDisplayString($setup.getEventDateText($setup.selectedEvent)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _createVNode(_component_van_icon, { name: "label" }),
                    _createElementVNode("span", {
                      style: _normalizeStyle({ color: $setup.getEventColor($setup.selectedEvent?.activityType) })
                    }, _toDisplayString($setup.getEventTypeText($setup.selectedEvent?.activityType)), 5)
                  ]),
                  ($setup.selectedEvent?.brand)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                        _createVNode(_component_van_icon, { name: "shop" }),
                        _createElementVNode("span", null, _toDisplayString($setup.selectedEvent?.brand), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t('calendar.eventDescription')), 1),
                  _createElementVNode("p", null, _toDisplayString($setup.selectedEvent?.description), 1)
                ]),
                _createElementVNode("div", {
                  innerHTML: $setup.selectedEvent?.content
                }, null, 8, _hoisted_44),
                ($setup.selectedEvent?.link)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                      _createVNode(_component_van_button, {
                        type: "primary",
                        block: "",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.handleEventAction($setup.selectedEvent)))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('calendar.participate')), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ])
  ]))
}